module.exports = __webpack_public_path__ + "fonts/effect-seething-hatred-37a410.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-seething-hatred.svg
// module id = 824
// module chunks = 0